import { NotFoundPage } from "@/pages/NotFound";
import { createRootRoute } from "@tanstack/react-router";

export const Route = createRootRoute({
  notFoundComponent: NotFoundPage,
});
